import { gql } from "@apollo/client";

export default gql`
	query ($vendorId: String!, $funnelId: String!, $skus: [String!]!) {
		geoCurrencies: geoCurrenciesV2(
			vendorId: $vendorId
			funnelId: $funnelId
			itemSetIds: $skus
		) {
			acceptedPayments {
				key
				value
			}
			countries {
				countryCode
				cardCurrencies
			}
		}
	}
`;
